import * as React from 'react';

import { Button } from '@ao-internal/components-react';
import * as digitalData from '@ao-internal/digital-data';

import FatalErrorBg from '../assets/images/fatal-error-bg@2x.png';
import FatalErrorImage from '../assets/images/fatal-error.jpg';
import patternBgImage from '../assets/images/pattern-bg.png';
import { TaggingEventNames } from '../globals';

interface FatalErrorProps {
	reloadCallback: (evt: React.MouseEvent) => void;
}

export const FatalError: React.FC<FatalErrorProps> = ({ reloadCallback }) => {
	React.useEffect(() => {
		digitalData.sendBeacon(TaggingEventNames.interaction, {
			type: 'render',
			element: 'fatal-error',
		});
	}, []);

	return (
		<div
			data-testid="chat-window-fatal-error"
			data-tag-area="fatal error"
			className="bg-gray-10 relative flex flex-col items-center justify-center flex-grow w-full pb-32 bg-repeat"
		>
			{/* BG pattern */}
			<div
				style={{
					backgroundImage: `url(${patternBgImage})`,
					backgroundSize: '208px',
				}}
				className="bg-gray-10 absolute inset-0 block"
			/>

			{/* BG Smile shape */}
			<div
				className="absolute inset-0 z-10 block bg-no-repeat bg-contain"
				style={{
					backgroundImage: `url(${FatalErrorBg})`,
					backgroundPosition: 'center 110%',
				}}
			></div>

			<div className="relative z-20 px-6 text-center">
				<img
					className="hidden block max-w-xs pb-6 m-auto"
					src={FatalErrorImage}
					alt=""
				/>
				<h2 className="text-display-sm mb-1">
					Oops! It looks like our system is&nbsp;down.
				</h2>
				<p className="text-body px-4 mx-auto mb-6">
					Sorry about that. Click Reload or pop back in a few&nbsp;minutes.
				</p>
				<Button
					className="hover:bg-cta-actionhover hover:text-white flex justify-center w-full mx-auto bg-white"
					data-testid="refresh-chatbot"
					data-tag-name="refresh chatbot"
					variant="secondary"
					onClick={(evt: React.MouseEvent) => reloadCallback(evt)}
				>
					<span className="c-button-icon">
						<span className="ico ico-refresh ico-lg block mr-2" />
					</span>
					Reload
				</Button>
			</div>
		</div>
	);
};

export default FatalError;
